window.registerModalIOSFix = function () {
    $(document).on('show.bs.modal', (e) => {
        let $target = $(e.relatedTarget);
        let $targetEl = $($target.data('bsTarget'));
        if (!$target.attr('id')) {
            $lastCLickedEl = $($target.closest('div.w-auto')).position();
            if ($lastCLickedEl) {
                previousScrollY = $lastCLickedEl.top;
            }
        }

        $targetEl.attr('data-open', 'true');

        // Works for IOS by writing 'something' to the active modal; it then seems to get registered again and then
        // applies the css rules again
        if ($('.ios-hack').length > 0) {
            setTimeout(() => {
                $('.ios-hack').text(' ');
            }, 500);
        }

        $('html').addClass('modal-open').css({
            marginTop: -previousScrollY,
            overflow: 'hidden',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            position: 'fixed',
        });
    }).on('hidden.bs.modal', (e) => {
        let $targetEl = $(e.target);
        if ($targetEl.length > 0) {
            $targetEl.attr('data-open', 'false');
        }
        $('#additives-modal').animate({ scrollTop: previousScrollY });

        if ($('[data-open=true]').length === 0) {
            $('html').removeClass('modal-open').css({
                marginTop: 0,
                overflow: 'visible',
                left: 'auto',
                right: 'auto',
                top: 'auto',
                bottom: 'auto',
                position: 'static',
            });
        }
    });
};
